import { createStyles } from 'antd-style'

import { LayoutContainer } from '../../layouts/components/Container'

import { BannerFloor } from './Banner'
import { BrandFloor } from './Brand'
import { ListingFloor } from './Listing'
import { NewsFloor } from './News'
import { SupplyDemandFormFloor } from './SupplyDemandForm'
import { SupplyDemandListFloor } from './SupplyDemandList'
import { TradeBoardFloor } from './TradeBoard'
import { TradeStatisticFloor } from './TradeStatistic'

const useStyles = createStyles(({ token }) => ({
  container: {
    marginBlockEnd: token.marginXL
  },
  wrapper: {
    display: 'flex',
    flexFlow: 'column nowrap',
    gap: token.marginSM,
    marginBlockStart: token.marginSM
  },
  otherFloor: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0,1fr) 384px',
    gridTemplateRows: '436px auto',
    gap: token.margin
  }
}))

export const HomePage = () => {
  const { styles } = useStyles()

  return (
    <div className={styles.container}>
      <BannerFloor />
      <LayoutContainer className={styles.wrapper}>
        <TradeStatisticFloor />
        <TradeBoardFloor />
        <ListingFloor />
        <div className={styles.otherFloor}>
          <NewsFloor />
          <SupplyDemandListFloor />
          <BrandFloor />
          <SupplyDemandFormFloor />
        </div>
      </LayoutContainer>
    </div>
  )
}
